import CrossSellProduct from './CrossSellProduct';
export default CrossSellProduct;
